import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface VacationPolicy {
  code: string
  accumulationTypeId: string
  generalFormula: string
  isDefault: boolean
  allowNegativeBalance: boolean
  bonusFormula: string
  liquidationFormula: string
  description: string
  effectiveConcepts: string[]
  employees: string[]
  periodEndDate: string
  periodRange: number
  periodVigency: number
  vacationConceptId: string
  paidVacationConceptId: string
  workingDays: string[]
  holidaysGroupId: string
}

export async function getVacationPolicies(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['vacation_policies.payroll_id=:payrollId']
  if (search) {
    where.push(
      `CONCAT(concepts.name, employees.code, employees.name, vacation_policies.code, vacation_policies.period_vigency) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          'group by vacation_policies.id',
          `ORDER BY (CASE WHEN vacation_policies.code ~ '^[0-9]+$' THEN CAST(vacation_policies.code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, vacation_policies.code ${dataOrder[0]}`
        ])
      : (modifier = [
          'group by vacation_policies.id',
          `order by ${dataOrder[1]} ${dataOrder[0]}`
        ])
    : (modifier = [
        'group by vacation_policies.id',
        "ORDER BY (CASE WHEN vacation_policies.code ~ '^[0-9]+$' THEN CAST(vacation_policies.code AS numeric) ELSE NULL END), vacation_policies.code"
      ])
  // result
  const response: any = await getData({
    tables: ['pg_vacation_policies'],
    fields: [
      'vacation_policies.id',
      'vacation_policies.code',
      'vacation_policies.is_default',
      'vacation_policies.code',
      "coalesce(string_agg(distinct employees.name,','),'') as employees_name",
      "coalesce(string_agg(distinct concepts.name,','),'') as concepts_name",
      'vacation_policies.period_vigency',
      'vacation_policies.updated_at'
    ],
    join: [
      'LEFT JOIN LATERAL jsonb_array_elements_text(vacation_policies.employees) r(employee) ON TRUE',
      'LEFT JOIN employees ON employees.id = r.employee::uuid',
      'LEFT JOIN LATERAL jsonb_array_elements_text(vacation_policies.effective_concepts) m(concept) ON TRUE',
      'LEFT JOIN concepts ON concepts.id = m.concept::uuid'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response[0]
}

export async function getVacationPolicy(id: string): Promise<VacationPolicy> {
  const data = await getData<any>({
    tables: ['pg_vacation_policies'],

    fields: [
      'id',
      'code',
      'payroll_id as payrollId',
      'accumulation_type_id as accumulationTypeId',
      'general_formula as generalFormula',
      'bonus_formula as bonusFormula',
      'liquidation_formula as liquidationFormula',
      'description',
      'effective_concepts as effectiveConcepts',
      'employees',
      'period_end_date as periodEndDate',
      'period_range as periodRange',
      'period_vigency as periodVigency',
      'vacation_concept_id as vacationConceptId',
      'paid_vacation_concept_id as paidVacationConceptId',
      'working_days as workingDays',
      'holidays_group_id as holidaysGroupId',
      'is_default as isDefault',
      'allow_negative_balance as allowNegativeBalance',
      'custom_fields as custom'
    ],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createVacationPolicy(
  data: VacationPolicy
): Promise<boolean> {
  const response: any = await http.post('vacation/policies', {
    code: data.code,
    accumulationTypeId: data.accumulationTypeId,
    generalFormula: data.generalFormula,
    isDefault: data.isDefault,
    allowNegativeBalance: data.allowNegativeBalance,
    bonusFormula: data.bonusFormula,
    liquidationFormula: data.liquidationFormula,
    description: data.description,
    effectiveConcepts: data.effectiveConcepts,
    employees: data.employees,
    periodEndDate: data.periodEndDate,
    periodRange: data.periodRange,
    periodVigency: data.periodVigency,
    vacationConceptId: data.vacationConceptId,
    paidVacationConceptId: data.paidVacationConceptId,
    workingDays: data.workingDays,
    holidaysGroupId: data.holidaysGroupId,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateVacationPolicy(
  data: VacationPolicy,
  id: string
): Promise<boolean> {
  const response: any = await http.put('vacation/policies/' + id, {
    code: data.code,
    accumulationTypeId: data.accumulationTypeId,
    generalFormula: data.generalFormula,
    isDefault: data.isDefault,
    allowNegativeBalance: data.allowNegativeBalance,
    bonusFormula: data.bonusFormula,
    liquidationFormula: data.liquidationFormula,
    description: data.description,
    effectiveConcepts: data.effectiveConcepts,
    employees: data.employees,
    periodEndDate: data.periodEndDate,
    periodRange: data.periodRange,
    periodVigency: data.periodVigency,
    vacationConceptId: data.vacationConceptId,
    paidVacationConceptId: data.paidVacationConceptId,
    workingDays: data.workingDays,
    holidaysGroupId: data.holidaysGroupId,

    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteVacationPolicy(id: string): Promise<boolean> {
  const response: any = await http.delete('vacation/policies/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
